import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import PropTypes from 'prop-types';
import React from 'react';
import modal from 'decorators/Modal/Modal';
var config = {
  autoplay: 1,
  color: 'white',
  disablekb: 1,
  modestbranding: 1,
  showinfo: 0,
  rel: 0
};
export var configString = Object.keys(config).map(function (key) {
  return "".concat(key, "=").concat(config[key]);
}).join('&');
export var modalConfig = {
  backdropClass: 'videos__overlay--fullscreen__backdrop',
  modalBorderClass: 'modal__border modal__border--video',
  centerVertically: true,
  headerClass: 'modal--colorful videos__overlay--fullscreen',
  lightClose: true,
  frameBorder: 0,
  modalContentClass: 'modal__content--video'
};
export var YouTubeVideoModalUnwrapped = function YouTubeVideoModalUnwrapped(_ref) {
  var videoId = _ref.videoId;
  var src = "https://www.youtube.com/embed/".concat(videoId, "?").concat(configString);
  return React.createElement("iframe", {
    allowFullScreen: true,
    className: "modal__video",
    frameBorder: 0,
    scrolling: "no",
    src: src
  });
};
YouTubeVideoModalUnwrapped.propTypes = {
  videoId: PropTypes.string.isRequired
};
export var Modal = modal(modalConfig)(YouTubeVideoModalUnwrapped);